import HasMany from './has_many'

export default class HasOne extends HasMany {
  getResult (record) {
    return super.getResult(record).first()
  }
}
